import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { change } from 'redux-form'
//@ts-ignore
import DisableableDropdownField from 'shared/FormFields/DisableableDropdownField'
import { withLookups, LookupType } from 'shared'
import { AccSearchNodesProps } from '../components.type'

const obtainNodes = (nodes = []) =>
  nodes.map((node) => ({
    id: node.ID,
    title: node.Title,
  }))

const makeOptions = (choices: Array<{ id: number; title: string }>) =>
  choices.map((choice, index) => ({
    key: index.toString(),
    text: choice.title,
    value: choice.id,
  }))

//@ts-ignore
@withLookups({
  type: LookupType.Search,
  query: ['Nodes as nodes'],
})
//@ts-ignore
@connect(
  (state, props: AccSearchNodesProps) => ({
    choices: obtainNodes(props.nodes),
  }),
  (dispatch) =>
    bindActionCreators(
      {
        changeField: change,
      },
      dispatch,
    ),
)
class AccSearchNodes extends React.Component<AccSearchNodesProps> {
  render() {
    const { choices } = this.props

    if (choices === undefined || choices === null) {
      return null
    }

    /* API does not send this node */
    choices.unshift({
      id: 0,
      title: 'ყველა ფილიალი',
    })

    const options = makeOptions(choices)

    return (
      <DisableableDropdownField
        name="nodes"
        options={options}
        disabilityCheckboxName="nodesDisabled"
        dropdownsShareOfWidth={14}
      />
    )
  }
}

export default AccSearchNodes
